<template>
  <Layout>
    <AntRow :gutter="20" class="content-row">
      <AntCol :span="24">
        <Instruction :platformList="platformList" />
      </AntCol>
      <AntCol :xs="24" :sm="24" :md="24" :lg="8" :xl="6">
        <ParameterForm :platformList="platformList" :testData="testData" />
      </AntCol>
      <AntCol :xs="24" :sm="24" :md="24" :lg="16" :xl="18">
        <TestReport :testData="testData" />
      </AntCol>
    </AntRow>
  </Layout>
</template>

<script>
import { reactive, computed } from 'vue'
import { useRoute } from 'vue-router'

import {
  Row as AntRow,
  Col as AntCol,
} from 'ant-design-vue'

import Layout from '@/components/SingleWalletTesting/Layout'
import Instruction from '@/components/SingleWalletTesting/Instruction'
import ParameterForm from '@/components/SingleWalletTesting/ParameterForm'
import TestReport from '@/components/SingleWalletTesting/TestReport'

import { PLATFORM_LIST } from '@/constants/singleWalletTesting'

export default {
  name: 'SingleWalletTesting',
  components: {
    AntRow,
    AntCol,
    Layout,
    Instruction,
    ParameterForm,
    TestReport,
  },
  setup() {
    const route = useRoute()
    const { brand } = route.meta

    const testData = reactive({
      isTesting: false,
      scenarioCounts: 0,
      testedScenarioCounts: 0,
      platformData: {},
      formData: {},
      testReportData: [],
      errorData: undefined,
    })

    const platformsByBrand = {
      'SANA TECH': [
        'BTG',
        'COMBO',
        'EVOLUTION',
        'FCEGAME',
        'FCFISH',
        'FCSLOT',
        'JDBEGAME',
        'JDBFISH',
        'JDBSLOT',
        'JDBTABLE',
        'JILIFISH',
        'JILISLOT',
        'JILITABLE',
        'NETENTSLOT',
        'NLC',
        'PGSLOT',
        // 'PINOYPERYAHAN',
        'PPEGAME',
        'PPLIVE',
        'PPSLOT',
        'RTSLOT',
        'SEXYBCRT',
      ],
      IN2SOLUTIONS: [
        'FCEGAME',
        'FCFISH',
        'FCSLOT',
        'JDBEGAME',
        'JDBFISH',
        'JDBSLOT',
        'JDBTABLE',
        'PGSLOT',
        'PPEGAME',
        'PPLIVE',
        'PPSLOT',
        'TADAEGAME',
        'TADAFISH',
        'TADASLOT',
        'TADATABLE',
        'THREEOAKS',
      ],
    }

    const awcExcludedPlatforms = [
      'THREEOAKS',
    ]

    const platformList = computed(() => (platformsByBrand[brand]
      ? platformsByBrand[brand].reduce((acc, platform) => {
        const platformData = PLATFORM_LIST.find(({ id }) => id === platform)
        if (platformData) acc.push(platformData)
        return acc
      }, [])
      : PLATFORM_LIST.filter(({ id }) => !awcExcludedPlatforms.includes(id))))

    return {
      testData,
      platformList,
    }
  },
}
</script>

<style scoped>
.content-row {
  padding: 32px 40px;
}
</style>
